import React from 'react';
import { Route } from 'react-router-dom';
import PrivacyPolicyManager from "../policy/privacy/PrivacyPolicyManager";
import ServicePolicyManager from "../policy/service/ServicePolicyManager";
import EulaPolicyManager from "../policy/eula/EulaPolicyManager";

const PolicyRoutes = () => {
  return (
    <>
      {/* Privacy Policy Routes */}
      <Route
        path="/policy/privacy/:lang/:version"
        render={({ match }) => {
          const { lang, version: versionParam } = match.params;
          const version = versionParam.replace(/(\d{4})(\d{2})(\d{2})/, '$1.$2.$3');
          
          return (
            <PrivacyPolicyManager
              language={lang}
              version={version}
            />
          );
        }}
      />
      <Route
        path="/policy/privacy/:langAndVersion"
        render={({ match }) => {
          const langAndVersion = match.params.langAndVersion;
          
          // 다양한 패턴 시도
          let matchResult = langAndVersion.match(/^([a-z]{2})_(\d{8})$/);
          if (!matchResult) {
            // ko_20240605 형태도 시도
            matchResult = langAndVersion.match(/^([a-z]{2})_(\d{6})$/);
          }
          if (!matchResult) {
            // ko_2025.07.09 형태도 시도
            matchResult = langAndVersion.match(/^([a-z]{2})_(\d{4}\.\d{2}\.\d{2})$/);
          }
          
          if (matchResult) {
            const [, lang, versionParam] = matchResult;
            
            let version = versionParam;
            // 20250709 형태를 2025.07.09로 변환
            if (versionParam.match(/^\d{8}$/)) {
              version = versionParam.replace(/(\d{4})(\d{2})(\d{2})/, '$1.$2.$3');
            }
            
            return (
              <PrivacyPolicyManager
                language={lang}
                version={version}
              />
            );
          } else {
            // 버전이 없는 경우 (예: ko만 있는 경우)
            if (langAndVersion.match(/^[a-z]{2}$/)) {
              const lang = langAndVersion;
              
              return (
                <PrivacyPolicyManager
                  language={lang}
                />
              );
            } else {
              return <div>Invalid URL pattern: {langAndVersion}</div>;
            }
          }
        }}
      />

      {/* Service Policy Routes */}
      <Route
        path="/policy/service/:lang/:version"
        render={({ match }) => {
          const { lang, version: versionParam } = match.params;
          const version = versionParam.replace(/(\d{4})(\d{2})(\d{2})/, '$1.$2.$3');
          
          return (
            <ServicePolicyManager
              language={lang}
              version={version}
            />
          );
        }}
      />
      <Route
        path="/policy/service/:langAndVersion"
        render={({ match }) => {
          const langAndVersion = match.params.langAndVersion;
          
          // 다양한 패턴 시도
          let matchResult = langAndVersion.match(/^([a-z]{2})_(\d{8})$/);
          if (!matchResult) {
            // ko_20250101 형태도 시도
            matchResult = langAndVersion.match(/^([a-z]{2})_(\d{6})$/);
          }
          if (!matchResult) {
            // ko_2025.01.01 형태도 시도
            matchResult = langAndVersion.match(/^([a-z]{2})_(\d{4}\.\d{2}\.\d{2})$/);
          }
          
          if (matchResult) {
            const [, lang, versionParam] = matchResult;
            
            let version = versionParam;
            // 20250101 형태를 2025.01.01로 변환
            if (versionParam.match(/^\d{8}$/)) {
              version = versionParam.replace(/(\d{4})(\d{2})(\d{2})/, '$1.$2.$3');
            }
            
            return (
              <ServicePolicyManager
                language={lang}
                version={version}
              />
            );
          } else {
            // 버전이 없는 경우 (예: ko만 있는 경우)
            if (langAndVersion.match(/^[a-z]{2}$/)) {
              const lang = langAndVersion;
              
              return (
                <ServicePolicyManager
                  language={lang}
                />
              );
            } else {
              return <div>Invalid URL pattern: {langAndVersion}</div>;
            }
          }
        }}
      />

      {/* EULA Routes */}
      <Route
        path="/policy/eula/:lang/:version"
        render={({ match }) => {
          const { lang, version: versionParam } = match.params;
          const version = versionParam.replace(/(\d{4})(\d{2})(\d{2})/, '$1.$2.$3');
          
          return (
            <EulaPolicyManager
              language={lang}
              version={version}
            />
          );
        }}
      />
      <Route
        path="/policy/eula/:langAndVersion"
        render={({ match }) => {
          const langAndVersion = match.params.langAndVersion;
          
          // 다양한 패턴 시도
          let matchResult = langAndVersion.match(/^([a-z]{2})_(\d{8})$/);
          if (!matchResult) {
            // ko_20240220 형태도 시도
            matchResult = langAndVersion.match(/^([a-z]{2})_(\d{6})$/);
          }
          if (!matchResult) {
            // ko_2024.02.20 형태도 시도
            matchResult = langAndVersion.match(/^([a-z]{2})_(\d{4}\.\d{2}\.\d{2})$/);
          }
          
          if (matchResult) {
            const [, lang, versionParam] = matchResult;
            
            let version = versionParam;
            // 20240220 형태를 2024.02.20으로 변환
            if (versionParam.match(/^\d{8}$/)) {
              version = versionParam.replace(/(\d{4})(\d{2})(\d{2})/, '$1.$2.$3');
            }
            
            return (
              <EulaPolicyManager
                language={lang}
                version={version}
              />
            );
          } else {
            // 버전이 없는 경우 (예: ko만 있는 경우)
            if (langAndVersion.match(/^[a-z]{2}$/)) {
              const lang = langAndVersion;
              
              return (
                <EulaPolicyManager
                  language={lang}
                />
              );
            } else {
              return <div>Invalid URL pattern: {langAndVersion}</div>;
            }
          }
        }}
      />
    </>
  );
};

export default PolicyRoutes; 